// src/config.js
// Trim any trailing slash just to avoid double slashes in requests
const API_URL =
  (process.env.REACT_APP_API_URL || "https://garishtha-wellness-backend-k4kxdo753q-el.a.run.app").replace(/\/+$/, "");

export default API_URL;
